import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { HeaderCheckbox } from 'legacy-modules/sales/reschedule/header-checkbox';
import * as React from 'react';

export const _columns: (props: {
  t: any;
  editable: boolean;
  dispatch?: any;
  name: any;
  activityColumn: any;
}) => IColumn<any>[] = ({ t, dispatch, name, editable, activityColumn }) => [
  {
    header: () => (
      <HeaderCheckbox name={name} dispatch={dispatch} isSelected={editable} />
    ),
    accessorKey: 'isSelected',
    minSize: 50,
    size: 50,
    dataType: ColumnDataType.checkbox,
    checkboxNoLabel: true,
  },
  {
    header: t('common:other'),
    accessorKey: 'activityId',
    minSize: 250,
    maxSize: 250,
    dataType: ColumnDataType.select,
    selectProps: activityColumn,
    required: true,
  },
  {
    header: t('common:type'),
    accessorKey: 'type',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.null,
    disabled: true,
  },
  {
    header: t('common:date'),
    accessorKey: 'date',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.date,
    required: true,
  },
  {
    header: t('common:price'),
    accessorKey: 'price',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    required: true,
  },
  {
    header: t('common:qty'),
    accessorKey: 'qty',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    required: true,
  },
  {
    header: t('common:total_price'),
    accessorKey: 'totalPrice',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
    disabled: true,
  },
  {
    header: t('common:description'),
    accessorKey: 'description',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.text,
  },
];
